module.exports = __webpack_public_path__ + "img/table-cells-large.ea3ff357.svg";